import React from 'react'

const FlagFill = ({ color }) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        fill={color}
        stroke={color}
        strokeWidth="2"
        d="M2 24V2c8-3.524 11 4.644 20 0v12c-8 4.895-13-4.103-20 0"
      />
    </svg>
  )
}

export default FlagFill
